(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8411],{

/***/ 4367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Company/memos/2021-11-24-affordability/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "Albert Chuang",
      dateTime: "2021-11-24",
      tag: "Memo",
      title: "Introducing the OneShop Affordability Program",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
          children: "Update:"
        }), " This program was replaced by our Small Seller program, which is now also no longer available. Learn more ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/company/memos/2022-03-02-ending-small-seller-program",
          children: "here."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Every seller starts off without any revenue. Even successful sellers sometimes have periods where they don\u2019t make sales. During these times, sellers need to decide whether to pay out of pocket to continue investing in their business. It\u2019s a tough decision to make."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We\u2019ve always wanted to help make OneShop more affordable so that every seller could get access to the best tools on the market regardless of how business is doing this week. Buyers are fickle. Success in retail changes with the seasons. Marketplace search feeds are competitive. Whether the odds are in your favor shouldn\u2019t affect your ability to invest in great tools that help you make your business grow."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["That\u2019s why today we\u2019re announcing the ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
          children: "OneShop Affordability Program"
        }), " \u2013 $10 off every week that you make less than $20 in sales. In most cases, if you are unlikely to afford OneShop you will only pay $1 a week."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The OneShop Affordability Program will go live on December 6th and the first credits will be issued on December 13th."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: "How eligibility is determined"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The sales numbers we\u2019ll use in determining eligibility will be your revenue, which is the amount before any costs. Costs may include shipping fees, marketplace fees, or cost of goods."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We will check your revenue using the seller accounts you have linked to OneShop. For the rest of 2021 while we\u2019re improving our multi-marketplace products, we will only be counting sales from Poshmark."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If a sale during a week gets cancelled or voided before the week\u2019s credit offer is issued, then that sale will not count towards your revenue."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: "How to redeem your affordability program credit"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We\u2019ll offer a place in the app for you to redeem your credit offers and send push notifications letting you know when you\u2019re eligible to claim credit."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/company/memos/2021-11-24-affordability.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Memo: Introducing the OneShop Affordability Program"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Memo: Introducing the OneShop Affordability Program"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-11-24T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-11-24T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Memo"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 10210:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/memos/2021-11-24-affordability",
      function () {
        return __webpack_require__(4367);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(10210); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);